<template>
  <div class="popup">
    <div class="popup-inner">
      <div class="closeDropBox-container">
        <h1>Drop Box Locations</h1>
        <div class="close-popup-container">
          <i class="fa fa-times-circle" @click="DropBoxTogglePopup"></i>
        </div>
      </div>

      <div class="DropBox-container">
        <div class="box-schedule-table">
          <h2>Pickup Schedule</h2>
          <table>
            <tr>
              <th>Placed in Box by 6pm</th>
              <th>Delivered</th>
            </tr>
            <tr>
              <td>Monday - Friday</td>
              <td>Next Day, excluding Legal Holidays</td>
            </tr>
          </table>
          <p>** unless indicated on the chart below, all drop box pick-up times are 6pm</p>
        </div>

        <div class="locationsHeader">
          <h2>Box Locations</h2>
        </div>

        <div class="main-table-container">
          <div
            v-for="(locations, county) in dropboxesByCounty"
            :key="county"
            class="county-section"
          >
            <div class="tabStructure" @click="toggleCounty(county)">
              <h2>{{ county }}</h2>

              <i
                :class="isCountyOpen(county) ? 'up-arrow' : 'down-arrow'"
              ></i>
            </div>

            <table v-if="isCountyOpen(county)" class="inner-table">
              <thead>
                <tr>
                  <th>City</th>
                  <th>Address</th>
                  <th>Location</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="dropbox in locations" :key="dropbox.id">
                  <td>{{ dropbox.city }}</td>
                  <td>{{ dropbox.address }}</td>
                  <td>
                    <a :href="dropbox.map" target="_blank" id="map-location">
                      Map
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
// import dropboxData from '/dropboxData.json'
import axios from 'axios'

export default {
    props: ['DropBoxTogglePopup'],

    data(){
        return{
            dropboxDataJSON: [],
            openCounties: {}
        }
    },
    computed: {
        dropboxesByCounty() {
        return this.dropboxDataJSON.reduce((groups, dropbox) => {
            if (!groups[dropbox.county]) {
            groups[dropbox.county] = [];
            }

            groups[dropbox.county].push(dropbox);
            return groups;
        }, {});
        }
    },
    methods:{
        toggleCounty(county) {
        this.openCounties[county] = !this.openCounties[county];
        },

        isCountyOpen(county) {
        return !!this.openCounties[county];
        },
        async getDropBoxData(){
            await axios.get('https://lrexsite-bucket155400-prod.s3.us-east-1.amazonaws.com/public/DropBoxData.json').then((response)=>{
              this.dropboxDataJSON = response.data;
            })
        },
        async getDropBoxDataZip(){
            await axios.get('https://lrexsite-bucket155400-prod.s3.us-east-1.amazonaws.com/public/DropBoxData.json').then((response)=>{
              this.dropboxDataJSON = response.data;
            })
        }
    },
    // mounted(){
    //     this.getDropBoxData();
    // },
    mounted(){
        if(this.$route.params.shipZip){
            this.getDropBoxDataZip();
        }else{
            this.getDropBoxData();
        }
    }
}
</script>

<style scoped>

.popup{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    animation: drop .5s ease forwards;
    
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;

    font-family: 'Work Sans', sans-serif;
}


.popup-inner{
    width: fit-content;
    height: auto;
    padding-bottom: 10px;
    border-radius: 15px;
    background-color: white;

    display: flex;
    flex-direction: column;
    text-align: left;

    box-shadow: rgba(0, 0, 0, 0.56) 0px 22px 70px 4px;
    overflow-y: hidden;
}

.popup-close{
    position: absolute;
    top: 5px;
    justify-content: center;
    margin-left: 2.5vw;
}

.DropBox-container{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding-left: 15px;
    padding-right: 15px;
}

@keyframes drop {
  from{margin-top: -5%;}
  to{margin-top: 1%;}
}

.close-popup-container{
    margin-left: auto;
    margin-right: 5px;
}

.fa-times-circle{
    color: #fff;
    font-size: 1.5em;
    cursor: pointer;
    transition-duration: .5s;
}

.fa-times-circle:hover{
    color: rgb(218, 218, 218);
    cursor: pointer;
    transition-duration: .5s;
}

.closeDropBox-container{
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #2cb6e4;
    border-radius: 15px 15px 0 0;
}

.closeDropBox-container h1{
    color: #fff;
    text-align: center;
    font-size: 1.8rem;
    flex: 1;
}


/*Table Structure*/
table {
  width: 100%;
  border-collapse: collapse;
}

th{
  background-color: #32ccfe;
}

.closeTab{
  margin-left: 5vw;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.tabStructure h2{
  cursor: pointer;
}

.tabStructure{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 15px;
  width: 100%;
  border-bottom: 1px solid #b3b3b3;
  transition-duration: .25s;
  cursor: pointer;
}

.tabStructure:hover{
    background-color: #fdfdfd;
    transition-duration: .25s;
}

.tabStructure h2{
    margin-bottom: 0;
}

.inner-table th:first-child, .box-schedule-table th:first-child{
    border-top-left-radius: 10px;
}

.inner-table th:last-child, .box-schedule-table th:last-child{
    border-top-right-radius: 10px;
}

.inner-table tbody tr:nth-of-type(even) {
    background-color: #f3f3f3;
}

.inner-table th{
    margin-top: 5px;
    padding: 5px;
}

.down-arrow {
  border: solid #32ccfe;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  margin-bottom: 3px;
  margin-left: auto;
}

.up-arrow {
  border: solid #32ccfe;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(-135deg);
  cursor: pointer;
  margin-left: auto;
}

.dropbox-table{
    margin-top: 0px;
    margin-bottom: 5vw;
}

.main-table-container{
    margin-top: 10px;
    padding: 5px;
    height: 55vh;
    width: 100%;
    overflow-y: auto;
    border: 1px solid #f3f3f3;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 15px;
}

@keyframes tabledrop {
  from{margin-top: -5%;}
  to{margin-top: 5px;}
}

.inner-table{
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    animation: tabledrop .5s ease forwards;
}

.inner-table td{
    padding: 5px;
    border-bottom: 1px solid #ddd;
}

.box-schedule-table table{
    border-collapse: separate;
    width: 100%;
}

.box-schedule-table td, .box-schedule-table th{
    padding: 5px;
    border: 1px solid #ddd;
}

.box-schedule-table th{
    background-color: #32ccfe;
}

.box-schedule-table{
    display: flex;
    flex-direction: column;
    margin-top: 1vw;
}

.box-schedule-table h2{
    margin-top: 0px;
    margin-bottom: 0px;
}

.locationsHeader{
    width: 100%;
    text-align: left;
    margin-bottom: 0;
}

.locationsHeader h2{
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 5px 10px;
    background-color: #fe804d;
    color: #fff;
    border-radius: 50px;
    width: fit-content;
}

@media only screen and (max-width: 1000px){

    .main-table-container{
        height: 60vh;
    }

}

@media only screen and (max-width: 640px){
    .popup-inner{
        margin-right: 5px;
        margin-left: 5px;
    }
}

@media only screen and (max-width: 500px){
    .closeDropBox-container h1{
        font-size: 1.4rem;
    }

    .dropbox-table td, .box-schedule-table td{
        padding: 10px 2px 10px 2px;
        font-size: 12px;
    }
}

</style>